import SummaryReducer from 'store/category-analyze/reducers';

export default SummaryReducer;
